angular.module('gym.contacts').factory('AllContacts', ["Restangular", "$rootScope", function(Restangular, $rootScope) {
  return function() {
    var params, type;
    params = $rootScope.toParams;
    type = params.contactType === 'non_attending_contacts' ? 'non_attending_contacts' : params.contactType;
    return Restangular.one('gyms', params.gymId).all(type);
  };
}]);
